/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const subAccounManageRouter = {
  path: '/subAccounManage',
  component: Layout,
  hidden: false,
  alwaysShow: true,
  redirect: 'noredirect',
  name: 'subAccounManage',
  meta: {
    title: '员工管理',
    icon: 'employee',
    roles: ['merchant']
  },
  children: [
    {
      path: 'subAccounList-124',
      component: resolve => require(['@/views/merchant/subAccounManage/subAccounList'], resolve),
      name: 'SubAccounList',
      meta: { title: '员工列表', noCache: false }
    },
    {
      path: 'rolePermission',
      component: resolve => require(['@/views/merchant/subAccounManage/rolePermission'], resolve),
      name: 'RolePermission',
      meta: { title: '角色管理', noCache: false }
    },
    {
      path: 'builtSubAccounList',
      component: resolve => require(['@/views/merchant/subAccounManage/builtSubAccounList'], resolve),
      name: 'BuiltSubAccounList',
      meta: { title: '新建员工', noCache: false }
    }
  ]
}

export default subAccounManageRouter



// WEBPACK FOOTER //
// ./src/router/merchant/subAccounManage.js